import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-testid": "layout-container" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "mx-auto px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Authenticator = _resolveComponent("Authenticator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeader),
    _createVNode(_component_Authenticator, {
      "hide-sign-up": true,
      "login-mechanisms": ['email']
    }, {
      "sign-in-header": _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h3", { class: "amplify-heading amplify-heading--3 login-heading" }, "Login", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}